import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import './Switch.scss';

const Switch = ({
  on,
}) => (
  <div className={classnames('Switch', { Switch__on: on })}>
    <div>
      <span className="Switch__indicator" />
    </div>
  </div>
);

Switch.propTypes = {
  on: PropTypes.bool,
};

Switch.defaultProps = {
  on: false,
};

const CheckboxSwitch = ({
  on,
  name,
  ...props
}) => (
  <div className="CheckboxSwitch">
    <input
      type="checkbox"
      className="CheckboxSwitch__Input"
      {...props}
      checked={on}
      id={name}
      name={name}
    />
    <Switch on={on} />
  </div>
);

CheckboxSwitch.propTypes = {
  on: PropTypes.bool,
  name: PropTypes.string,
};

CheckboxSwitch.defaultProps = {
  on: false,
  name: '',
};

export default CheckboxSwitch;
export { Switch };
